/**
 *
 * Banner
 *
 */

import React from "react";
import SectionContainer from "./styles/BannerWrapper";

class Banner extends React.PureComponent {
  render() {
    return (
    <SectionContainer className="salary-hero-section">
      <img src="/assets/img/salary-hero-bg-shape.svg" alt="" className="salary-hero-br-shape" />
      <div className="container">
        <div className="salary-hero-section__inner">
          <div className="salary-hero__content">
            <h1>
              <img src="/assets/img/sh-h1-shape.svg" alt="" className="h1-shape" />
              <span>Salary</span>
              <br />
              <span className="stl-1">calculator</span>
            </h1>
            <p>Want to know how your salary compares to others' across the globe? Or what you can expect as you progress up the career ladder? Fill in a few fields below, explore the advanced filters, and the salary calculator will do the rest for you! </p>
          </div>
          <a href="#" className="default-button bottom-button">Contribute to salary survey</a>
        </div>
      </div>
    </SectionContainer>
    );
  }
}

export default Banner;